export default __webpack_public_path__ + "static/media/ic_nigeria.662c935a.svg";